import { __rest, __assign } from 'tslib';
import React from 'react';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';

var appearanceClasses = {
    primary: "tw-border-t tw-border-gray-300 dark:tw-border-gray-700",
    striped: "tw-border-t tw-border-gray-300 tw-bg-gray-100 dark:tw-border-gray-700 dark:tw-bg-gray-1000",
    clear: "tw-border-t-0"
};
function CardFooter(_a) {
    var addClassName = _a.addClassName, _b = _a.appearance, appearance = _b === void 0 ? "primary" : _b, children = _a.children, dataMetrics = _a.dataMetrics, dataTestId = _a.dataTestId, secondaryContent = _a.secondaryContent, passThrough = __rest(_a, ["addClassName", "appearance", "children", "dataMetrics", "dataTestId", "secondaryContent"]);
    return (React.createElement("div", __assign({ "data-metrics": dataMetrics, "data-testid": dataTestId || "card-footer", className: classNames("tw-box-border tw-border-solid tw-border-b-0 tw-border-l-0 tw-border-r-0 tw-flex tw-justify-between tw-flex-0 tw-rounded-b tw-px-4 tw-py-2", appearanceClasses[appearance], addClassName) }, passThrough),
        React.createElement("div", { className: "tw-font-lato tw-flex tw-items-center tw-space-x-2" }, secondaryContent),
        React.createElement("div", { className: "tw-font-lato tw-flex tw-items-center tw-space-x-2" }, children)));
}

export { CardFooter };
//# sourceMappingURL=CardFooter.esm.js.map
